const React = require('react');

function getSite(siteId) {
  const alternateCountries = [
    { id: 'MLA', domain: '.com.ar' },
    { id: 'MLB', domain: '.com.br' },
    { id: 'MLM', domain: '.com.mx' },
    { id: 'MLC', domain: '.cl' },
    { id: 'MCO', domain: '.com.co' },
    { id: 'MPE', domain: '.com.pe' },
    { id: 'MLU', domain: '.com.uy' },
  ];

  return alternateCountries.find((element) => element.id === siteId).domain;
}

module.exports = { getSite };
